import { useMemo, type JSX } from 'react';

import { AssetsContext } from './assets.context';

import { useAssets, useLoadFonts } from './assets.hooks';

export function Assets({ children }: ChildreProps) {
	const { fonts, isLoading, error } = useAssets();
	useLoadFonts(fonts);

	const contextValue = useMemo(
		() => ({
			isLoading,
			error,
			fonts,
		}),
		[isLoading, error, fonts],
	);

	return (
		<AssetsContext.Provider value={contextValue}>
			{children}
		</AssetsContext.Provider>
	);
}

export function Fonts(_props: ChildreProps) {}

interface ChildreProps {
	children: string | JSX.Element | JSX.Element[];
}
